"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PROSPECTIVE: 'prospective',
    SHORTLISTED: 'shortlisted',
    APPLYING: 'applying',
};
//# sourceMappingURL=applicationGroupTypes.js.map